var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_17810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.9478C10.2884 10.9478 9.16678 9.84011 9.16678 8.47903C9.16678 7.11795 10.2884 6.01031 11.6667 6.01031H13.3333V2.71872C13.3333 1.35764 12.2116 0.25 10.8333 0.25H1.87513C1.60094 0.25 1.34429 0.3832 1.1885 0.606205C1.03347 0.82921 0.998526 1.11324 1.09679 1.36578L7.13845 17.0011C7.26097 17.3204 7.57088 17.5311 7.91679 17.5311H10.8333C12.2116 17.5311 13.3333 16.4234 13.3333 15.0623V10.9478H11.6667Z",
    fill: "#83889D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5141 12.531C15.2033 12.4034 14.9999 12.1031 14.9999 11.7705V9.30181H11.6667C11.2066 9.30181 10.8333 8.93324 10.8333 8.47895C10.8333 8.02465 11.2066 7.65609 11.6667 7.65609H14.9999V5.18737C14.9999 4.85482 15.2033 4.55451 15.5141 4.42689C15.8257 4.29941 16.1841 4.37023 16.4223 4.60559L19.7557 7.89718C20.0815 8.21888 20.0815 8.73902 19.7557 9.06072L16.4223 12.3525C16.1841 12.5877 15.8257 12.6585 15.5141 12.531Z",
    fill: "#ED9373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20497 1.98003L2.19755 0.331753C1.06749 -0.0113434 0 0.812419 0 1.8961V16.7084C0 17.4121 0.453334 18.04 1.12838 18.2704L6.13488 19.9187C6.31906 19.9746 6.48827 20.0002 6.66665 20.0002C7.58583 20.0002 8.3332 19.262 8.3332 18.3543V3.54197C8.3332 2.83845 7.87986 2.21057 7.20497 1.98003Z",
    fill: "#B5B5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_17810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.75,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ced74f35226182307300625ea49f77da.svg";
export { ForwardRef as ReactComponent };